export default __webpack_public_path__ + "static/media/lowerCostOwnership.8eb48873.svg";